import { createContext as e, useContext as t } from "react";
const o = e({ id: "", required: !1 }), i = () => t(o);
export {
  o as FieldContext,
  i as useField
};
